import React, { useRef, useState, useEffect } from 'react';
import classNames from 'classnames';
import useOnScreen from '../../../hooks/useOnScreen';
import { Star10 } from '../../../assets/stars';
import './styles.css';

const RatingStats = ({ reviewAggregates, title, reviewLink, ...props }) => {
  const { averageRating, count: total } = reviewAggregates || {};

  const [viewed, setViewed] = useState(false);
  const ref = useRef();
  const onScreen = useOnScreen(ref);

  useEffect(() => {
    if (onScreen) setViewed(true);
  }, [onScreen]);

  return (
    <div
      className={classNames('RatingStats__root', {
        'RatingStats__root--onScreen': viewed,
      })}
      ref={ref}
    >
      <div className="RatingStats__text">
        {title && <span className="RatingStats__title">{title}</span>}
        <div className="RatingStats__rating">
          {averageRating} <Star10 fill="#ffc413" width={31} />
        </div>
        <div className="RatingStats__total">
          {reviewLink ? (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a onClick={reviewLink}>{total} reviews</a>
          ) : (
            <>{total} reviews</>
          )}
        </div>
      </div>
      <svg viewBox="0 0 36 36" className="RatingStats__chart" {...props}>
        <path
          className="RatingStats__circleBg"
          d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        <path
          className="RatingStats__circle"
          strokeDasharray="90, 100"
          d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
        />
      </svg>
    </div>
  );
};

export default RatingStats;
